import type {Disclosure} from "@/common/data/Disclosure";
import {injectable} from "inversify";

@injectable()
export default class DisclosureUtils {
    hasEmailableDisclosures = (disclosures: Array<Disclosure>) =>
        disclosures.some(disclosure => disclosure.allowEmail);
}